import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
//! DS component classes load AFTER index.css (Tailwind preflight) so .btn fills
//  win the cascade over preflight's `[type=button]{background:initial}` reset.
import "./styles/ds-components.css";
import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </QueryClientProvider>
);

// Tear down any previously-registered service worker + its caches.
// An earlier build registered a caching SW at boot; it pinned a stale app-shell
// in the browser and defeated hard-refresh (the SW answered before the network).
// Unregister everything and purge Cache Storage so the app always loads fresh.
// (Re-introduce a SW deliberately later if we want offline/push — not at boot.)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
}
if (typeof caches !== 'undefined') {
  caches.keys()
    .then((keys) => keys.forEach((k) => caches.delete(k)))
    .catch(() => {});
}
